<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<child-onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="store.sendingIdentificationInformation$ | async"
  (back)="service.goToPreviousStep()"
  (forward)="submit()"
>
  @if (hasFilesAlreadyUploaded()) {
    <p class="zero-text p-huge-med">{{ 'child-onboarding.identification.headline' | transloco }}</p>
    <div class="zero-text p-base-reg mb-3">
      {{ 'child-onboarding.identification.already-uploaded' | transloco }}
    </div>
    <a class="zero-text link mb-3" (click)="restartUpload()">
      {{ 'child-onboarding.identification.restart-upload' | transloco }}
    </a>
  } @else {
    <p class="zero-text p-huge-med">{{ 'child-onboarding.identification.pre' | transloco }}</p>
    <p class="zero-text p-huge-med">{{ 'child-onboarding.identification.headline' | transloco }}</p>
    <p class="zero-text p-base-reg">{{ 'child-onboarding.identification.hint' | transloco }}</p>
    <web-design-system-select [items]="situationItems()" (selectItem)="selectSituation($event)" class="mb-4" />
    <hr />
    @if (store.selectedSituation(); as situation) {
      @if (!situation.isValid) {
        <div class="zero-text p-base-reg course-red mt-3" data-zid="situation-error">
          {{ 'child-onboarding.identification.situation.error' | transloco }}
        </div>
      } @else {
        @for (key of filesToUploadKeys(); track key) {
          <div class="mt-3">
            <h5>{{ documentTypeNameMap[key] }}</h5>
            @if (filesToUpload()[key]?.file; as file) {
              <div>
                <div class="mt-2 d-flex flex-wrap">
                  <div>{{ file.fileName }}:&nbsp;</div>
                  @if (!file.uploadError) {
                    <div>
                      {{ `child-onboarding.identification.file-upload.upload_${(!file.uploadProgress || file.uploadInProgress)?'progress':'complete'}` | transloco }}
                    </div>
                  }
                  @if ((file.uploadProgress === 100 && file.uploadInProgress === false) || file.uploadError) {
                    <div>
                      <a class="cursor-pointer" (click)="deleteUploadedFile(file)">
                        <svg class="icon icon-24 icon-active mb-1 ml-2">
                          <use class="icon-trashcan" xlink:href="/assets/img/svgs/svgset.svg#trashcan" />
                        </svg>
                      </a>
                    </div>
                  }
                </div>
                <div class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    [class.bg-success]="file.uploadProgress === 100 && file.uploadInProgress === false && !file.uploadError"
                    [class.bg-danger]="file.uploadError"
                    [ngStyle]="{ width: file.uploadProgress + '%' }"
                    [attr.aria-valuenow]="file.uploadError ? '0' : file.uploadProgress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {{ file.uploadError ? '0' : file.uploadProgress }} %
                  </div>
                </div>
              </div>
              <div class="mt-2 opacity-container" [class.active]="file.uploadProgress === 100">
                <web-design-system-checkbox
                  [isChecked]="filesToUpload()[key]?.confirmed"
                  (isCheckedChange)="toggleConfirmed(key, $event)"
                  [style]="'blue'"
                >
                  <span class="zero-text p-base-reg">
                    {{ (`child-onboarding.identification.file-upload.${key}.confirm` | transloco) === 
                        `child-onboarding.identification.file-upload.${key}.confirm` 
                          ? (`child-onboarding.identification.file-upload.DEFAULT.confirm` | transloco)
                          : (`child-onboarding.identification.file-upload.${key}.confirm` | transloco) }}
                  </span>
                </web-design-system-checkbox>
              </div>
            } @else {
              <form #fileUpload="ngForm" (ngSubmit)="submitFileUpload(key, fileUpload, fileUploadElem)" class="mt-2">
                <input
                  type="file"
                  id="tempFiles"
                  name="tempFiles"
                  ngModel
                  (change)="fileUpload.onSubmit($event)"
                  multiple="multiple"
                  #fileUploadElem
                  accept="application/pdf, image/*"
                  hidden
                />
                <label for="tempFiles" class="d-flex align-items-center">
                  <web-design-system-button type="secondary" size="small" class="mr-3" (click)="fileUploadElem.click()" [isSubmit]="true">
                    {{ 'child-onboarding.identification.file-upload.btn-upload' | transloco }}
                  </web-design-system-button>
                  <div class="font-size-smaller2 text-color-primary">
                    {{ 'child-onboarding.identification.file-upload.max-size' | transloco }}
                  </div>
                </label>
              </form>
            }
          </div>
          <hr />
        }

        @if (errors.length) {
          <div class="row mt-3">
            <div class="col-12 text-color-error">
              @for (err of errors; track $index) {
                <p>{{ err | transloco }}</p>
              }
            </div>
          </div>
        }
      }
    }
  }
</child-onboarding-container>
